export default __webpack_public_path__ + "static/media/notes.8a203631.mp4";